import type { AppStore } from '../../../stores/redux/setup';

let reduxStore: AppStore | undefined;

/**
 * Wires the Redux singleton into Segment tracking after `setupStore()` completes.
 * Keeps `segmentTracker` free of a static `import { store }` and avoids a circular
 * init graph: `setup` → `apiServiceErrorHandler` → `authService` → `track` → segment tracker → store → `setup`.
 */
export function bindSegmentTrackerStore(store: AppStore): void {
  reduxStore = store;
}

export function getSegmentTrackerStore(): AppStore {
  if (reduxStore === undefined) {
    throw new Error(
      'Segment tracker Redux store is unset; bindSegmentTrackerStore must run after the store is created.',
    );
  }
  return reduxStore;
}
